export default "__VITE_ASSET__ada06d9f__"